// NOTE: Consider implementing the singleton pattern if the geoJSON will remain the same for all isLocationInArea calls
(function() {
  async function isLocationInArea(geoJSON) {
    const position = await getUserGeolocation();
    if (!position) return false;

    const regions = extractRegionsData(geoJSON);
    if (!regions) return false;

    const isInArea = regions.some((polygon) => {
      return pointInPolygon(position.coords, polygon);
    });
    return isInArea;
  }

  async function getUserGeolocation() {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }

  function extractRegionsData(geoJSONstring) {
    try {
      const parsedGeoJSON = JSON.parse(geoJSONstring);

      const regions = parsedGeoJSON.reduce((acc, jsonMetaobject) => {
        jsonMetaobject.geojson.features.forEach((feature) => {
          if (feature.geometry.type === "Polygon") {
            acc = [...acc, feature.geometry.coordinates[0]];
          }
        });
        return acc;
      }, []);

      return regions;
    } catch (error) {
      console.error("Error extracting regions data from geoJSON", error);
      return null;
    }
  }

  function pointInPolygon(point, polygon) {
    const x = point.longitude,
      y = point.latitude;
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i][0],
        yi = polygon[i][1];
      const xj = polygon[j][0],
        yj = polygon[j][1];

      // Edge cases - if point is exactly on a vertex, horizontal edge or vertical edge
      if (x === xi && y === yi) return true;
      if (yi === yj && y === yi && x >= Math.min(xi, xj) && x <= Math.max(xi, xj)) return true;
      if (xi === xj && x === xi && y >= Math.min(yi, yj) && y <= Math.max(yi, yj)) return true;

      const rayCrossesVerticalLine = yi > y !== yj > y;
      if (!rayCrossesVerticalLine) continue;

      if (Math.abs(yj - yi) < Number.EPSILON) continue;

      const t = (y - yi) / (yj - yi);
      const intersectionX = xi + t * (xj - xi);
      
      if (x < intersectionX) {
        inside = !inside;
      }
    }
    return inside;
  }

  window.isLocationInArea = isLocationInArea;
})();